// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { Input } from "src/modules/simulation-panel/jsx/input.jsx";


export class AttributesSection extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            active_attributes: [],
            remount_key: ''
        };

        // Binds
        this.toggleAccordion = this.toggleAccordion.bind(this);
        this.handleResetAttributes = this.handleResetAttributes.bind(this);
    }


    //
    // Events
    //

    toggleAccordion(key) {
        var this_component = this;
        var active_attributes = this_component['state']['active_attributes'];

        if (active_attributes.indexOf(key) > -1) {
            active_attributes = active_attributes.filter(function(val) {
                return val !== key;
            });
        } else {
            active_attributes.push(key);
        }

        this_component.setState({
            active_attributes: active_attributes
        });
    }

    handleResetAttributes() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        
        var personalisation_in_storage = squiz.fn.getStorage('userpersonalisation', 'session', 'json');
        var original_personalisation = personalisation_in_storage['data'];

        helpers.updatePersonalisation(original_personalisation);

        // Force refresh of child Inputs
        this_component.setState({
            remount_key: new Date().getTime()
        });
    }



    //
    // Functions
    //

    renderAttributeList() {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];
        var all_attributes = configuration['all_attributes'];
        var active_attributes = this_component['state']['active_attributes'];

        var attributes_arr = [];

        if (all_attributes) {
            for (var key in all_attributes) {

                if (!all_attributes.hasOwnProperty(key)) continue;

                var attribute = all_attributes[key];
                attributes_arr.push(attribute);
            };
        }

        var attributes_sorted = attributes_arr.sort(function(a, b) {
            if (a['name'] > b['name']) {
                return 1;
            }
            if (a['name'] < b['name']) {
                return -1;
            }
            return 0;
        });

        var list_items = attributes_sorted.map(function(attribute, key) {
            var active = false;
            if (active_attributes.indexOf(key) > -1) {
                active = true;
            }

            // Forces a refresh of all Inputs when 'remount_key' is updated
            var date_key = key + '-' + this_component['state']['remount_key'];

            return (
                <Input
                    key={date_key}
                    id={key}
                    active={active}
                    attr={attribute}
                    handleToggle={this_component.toggleAccordion}
                />
            );

        });

        return (
            <ul className="simulation-panel__dialogue__modify-attributes__list">
                {list_items}
            </ul>
        );
    }
    


    //
    // Render
    //

    render() {
        var this_component = this;
        var clickHandler = this_component.handleResetAttributes;
        var attribute_list = this_component.renderAttributeList();

        return (
            <div className="attributes-section">
                <div className="simulation_panel__dialogue__info-text">You may choose 1 or more attributes to build your student profile</div>
                <button className="simulation-panel__dialogue__modify-attributes__clear" onClick={clickHandler}>Reset attributes</button>
                
                {attribute_list}
            </div>
            
        );
    }

};

AttributesSection.contextType = PortalContext;

